import React from 'react'
import * as UI from 'ui'
import AdminPage from 'pages/app/AdminPage'
import { Translation, Translator } from '@morningtrain/react-translations'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { SelectedDepartmentFilter } from 'support/filters'
import { Model, WhenModel } from '@morningtrain/react-resources'
import PeriodFilterSyncedWithPage from 'support/filters/PeriodFilterSyncedWithPage'
import GuestCountLineChartLoader from 'widgets/charts/GuestCountLineChartLoader'
import TotalGuestCountSummaryWidget from 'widgets/economy/partials/TotalGuestCountSummaryWidget'
import WhenMultipleDepartmentsAreSelected from 'support/conditionals/WhenMultipleDepartmentsAreSelected'
import GuestCountTableByDepartment from 'pages/app/economy/partials/GuestCountTableByDepartment'
import CookieFilter from "support/filters/CookieFilter";

export default function GuestCount (props) {
  return (
    <AdminPage>
      <Translator namespace='economy.pages.guest_count'>
        <UI.PageHeader title={<TranslatedTitle />}>
          <PeriodFilterSyncedWithPage selectors={['this_month', 'latest_year', 'this_year']} />
        </UI.PageHeader>

        <UI.CardGroup>

          <Model resourceName='economy' operationName='guest_count_development'>
            <SelectedDepartmentFilter />
            <CookieFilter name='period' cookieKey='page.filters.period' />

            <WhenModel>
              <div className='space-x-4 flex'>
                <TotalGuestCountSummaryWidget className='w-1/3' />
                <UI.Card className='w-2/3'>
                  <UI.CardHeader>
                    <UI.SecondaryHeading width='w-1/2'>
                      <Translation name='chart_title' />
                    </UI.SecondaryHeading>
                    <UI.Legend className='w-1/2'>
                      <UI.LegendItem colorHex='#616DE1'>
                        <Translation name='generic.guest_count' />
                      </UI.LegendItem>
                      <UI.LegendItem colorHex='#E5483F'>
                        <Translation name='generic.guest_count' /> (LY)
                      </UI.LegendItem>
                      <WhenMultipleDepartmentsAreSelected>
                        <UI.LegendItem colorHex='#6d21af'>
                          <Translation name='generic.guest_count' /> (1:1)
                        </UI.LegendItem>
                      </WhenMultipleDepartmentsAreSelected>
                    </UI.Legend>
                  </UI.CardHeader>
                  <div className='w-full h-96'>
                    <GuestCountLineChartLoader />
                  </div>
                </UI.Card>
              </div>
              <WhenMultipleDepartmentsAreSelected>
                <GuestCountTableByDepartment />
              </WhenMultipleDepartmentsAreSelected>
            </WhenModel>

          </Model>
        </UI.CardGroup>
      </Translator>
    </AdminPage>
  )
}
